import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { IonBackButton, IonButtons, IonContent, IonHeader, IonTitle, IonToolbar } from '@ionic/react';
import { useTranslation } from 'react-i18next';
import DeleteProfile from '@/components/DeleteProfile';
import { FirebaseAuthentication } from '@capacitor-firebase/authentication';
import { useState, useEffect } from 'react';

const AccountSettings = () => {
  const { t } = useTranslation(['MGP', 'Settings']);
  const [user, setUser] = useState<any>(null);

  useEffect(() => {
    const getCurrentUser = async () => {
      const result = await FirebaseAuthentication.getCurrentUser();
      setUser(result.user);
    };
    getCurrentUser();
  }, []);

  return (
    <>
      <IonHeader>
        <IonToolbar className="md:hidden">
          <IonButtons slot="start">
            <IonBackButton text={t('back')} defaultHref="/settings" />
          </IonButtons>
          <IonTitle>{t('my_account')}</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <h1 className="hidden md:block text-3xl font-bold pt-6">{t('my_account')}</h1>
        <div className="space-y-4 p-2">
          <Card className='border-input'>
            <CardContent className="space-y-4 pt-4">
              <div className="flex items-center space-x-4">
                <Avatar className="size-16">
                  <AvatarImage src={user?.photoURL || undefined} />
                  <AvatarFallback>{user?.email?.charAt(0).toUpperCase()}</AvatarFallback>
                </Avatar>
                <div>
                  <h3 className="font-medium">{user?.displayName || t('unnamed_user')}</h3>
                  <p className="text-sm text-muted-foreground">{user?.email}</p>
                </div>
              </div>

              <div className="space-y-2">
                <h4 className="font-medium">{t('account_info')}</h4>
                <div className="grid grid-cols-2 gap-2 text-sm">
                  <div className="text-muted-foreground">{t('email_verified')}</div>
                  <div>{user?.emailVerified ? t('yes') : t('no')}</div>
                  <div className="text-muted-foreground">{t('provider')}</div>
                  <div>{user?.providerData[0]?.providerId || t('unknown')}</div>
                  <div className="text-muted-foreground">{t('created')}</div>
                  <div>{user?.metadata.creationTime ? new Date(user.metadata.creationTime).toLocaleDateString() : t('unknown')}</div>
                </div>
              </div>

            </CardContent>
          </Card>
          <DeleteProfile />

        </div>
      </IonContent>
    </>
  );
};

export default AccountSettings;
